import { render } from "./com-order-refund.vue?vue&type=template&id=24da8b90"
import script from "./com-order-refund.vue?vue&type=script&lang=js"
export * from "./com-order-refund.vue?vue&type=script&lang=js"
script.render = render

export default script